import React from 'react'
import { Tab } from 'react-bootstrap'
import { getName, partnerDob } from '../../../CommonMethhods/CommonMethods';
import Loader from '../../../Components/Common/Loader';
import { Constants } from '../../../CommonMethhods/Constants';

function PartnerAdminOnboardingLeads(props) {
  let linecard = props?.linecard;
  let serverError = props?.serverError;
  let serachBar = props?.serachBar;
  return (
    <>
      <Tab.Pane eventKey="Leads" className="createdClass">
        <div className="row">
          <div className="col-12">
            <div
              className="oboarding-block-wrapper card-box alert-table text-center partneradmin-wrapper"
              onScroll={(e) => props?.handleScroll(e)}
            >
              {serachBar?.length > 0 ? (
                <div
                  className={` ${linecard === "block-active col-division-5"
                    ? "onboarding-card-wrapper"
                    : ""
                    }`}
                >
                  {serachBar.map((item) => {
                    return (
                      <div className={`w-100 bottom-25 ${linecard}`}>
                        <div className="card-box onboarding-card">
                          <div className="client-img-checkbox-wrapper">
                            <div className="client-img-wrapper">
                              <div className="profile-image">
                                {getName(item?.name)}
                              </div>
                            </div>
                          </div>
                          <div className="onboarding-card-content partner-card">
                            <div className="onboarding-card-top">
                              <div className="user-email-wrapper">
                                <p className="username">
                                  {/* <span
                                    onClick={() => {
                                      getPartnerId(item?.id);
                                      navigate("/partner-application");
                                    }}
                                  > */}
                                  {item?.name}
                                  {/* </span> */}
                                </p>
                                <p className="email">{item?.email}</p>
                              </div>
                            </div>

                            <div className="clientname-info ">
                              <div className="client-data-partner">
                                <ul className="call-web-wrapper">
                                  <li className="created-time-wrapper">
                                    <span className="icon-calendar onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>{partnerDob(item?.created_at)}</span>
                                    </span>
                                  </li>
                                </ul>
                                <div className="client-info-status">
                                  <ul className="call-web-wrapper">
                                    <li className="created-time-wrapper">
                                      <span className="icon-client-code onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>{item?.pan}</span>
                                      </span>
                                    </li>
                                    <li>
                                      <span className="icon-phone-icon onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>{item?.mobile}</span>
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="right-box">
                            <ul class="progress-bar">
                            <li className={`${item?.pan_upload === true ? 'active' : ''}`}> <span>Aadhar and Pan Verified</span>
                              </li>
                              <li className={`${item?.personal_details === true ? 'active' : ''}`}> <span>Personal Details</span></li>
                              <li className={`${item?.bank_details === true ? 'active' : ''}`}><span> Bank Details</span></li>
                              <li className={`${item?.document_upload === true ? 'active' : ''}`}><span>Documents Uploaded</span> </li>
                              <li className={`${item?.esign_completed === true ? 'active' : ''}`}><span>esign</span> </li>
                            </ul>
                            {(localStorage.getItem("partnerRole") === "Partner" ||
                            localStorage?.getItem("partnerRoleNew") === "Partner") && 
                            (item?.esign_completed === false) ?
                              <div>
                                <span className="icon-Edit" onClick={() => props?.getEdit(item.id,item.client_type)}>
                                </span>
                              </div> : null}
                          </div>

                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : serverError ?
                <h4 className="alert-title mb-0">{serverError}</h4> : (
                <div className="alert-title mb-0">
                  <h3>{Constants.No_Data}</h3>
                </div>
              )}
              {props.scrollLoader && (
                <div className="loader-center">
                  <Loader />
                </div>
              )}
            </div>
          </div>
        </div>
      </Tab.Pane>
    </>
  )
}

export default PartnerAdminOnboardingLeads